if (!customElements.get('quick-add-button')) {
  class QuickAddButton extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this))
    }

    handleClick() {
      const productUrl = this.dataset.productHref
      if (!productUrl) return
      const quickModal = document.querySelector('quick-modal')
      if (!quickModal) return
      quickModal.dataset.productHref = productUrl
      quickModal.dataset.pageType = this.dataset.pageType
      if (this.dataset.showOnlyClearance) {
        quickModal.dataset.showOnlyClearance = this.dataset.showOnlyClearance
      }
      const isRebuyRecommendation = this.isRebuyRecommendation()
      if (isRebuyRecommendation) {
        quickModal.dataset.ruleId = this.closest('rebuy-recommendations').dataset.ruleId
      }
      quickModal.open(isRebuyRecommendation)
      this.sendDataLayer()
    }

    // Check if quick add button is inside a rebuy recommendation to send the correct flag
    isRebuyRecommendation() {
      return this.closest('rebuy-recommendations') ? true : false
    }

    sendDataLayer() {
      const productFormattedPrice = this.dataset.productFormattedPrice
      const currency = this.dataset.currency
      const title = this.dataset.productTitle
      const productId = Number(this.dataset.productId)
      const productVendor = this.dataset.productVendor
      const productType = this.dataset.productType

      dataLayer.push({ ecommerce: null })
      dataLayer.push({
        event: 'quick_add_to_cart_open',
        ecommerce: {
          value: productFormattedPrice,
          currency: currency,
          items: [
            {
              item_id: productId,
              item_name: title,
              item_brand: productVendor,
              item_category: productType,
              currency: currency,
              price: productFormattedPrice,
            },
          ],
        },
      })
    }
  }
  customElements.define('quick-add-button', QuickAddButton)
}
